import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../supabase-client";
import { hashPassword } from "../../utils/hashPassword";

const ResetPassword = () => {
   const [email, setEmail] = useState("");
   const [newPassword, setNewPassword] = useState("");
   const [error, setError] = useState("");
   const [success, setSuccess] = useState("");
   const navigate = useNavigate();

   const handleResetPassword = async (e) => {
      e.preventDefault();
      setError("");
      setSuccess("");

      if (!email || !newPassword) {
         setError("Por favor completa todos los campos");
         return;
      }
      const hashedPassword = await hashPassword(newPassword);

      try {
         const { error: dbError } = await supabase
         .from("usuarios")
         .update(
            {
               password_hash: hashedPassword,
               perfil: 18, // Email no confirmado
            }
         )
         .eq("email", email);
        
         if (dbError) throw dbError;

         setSuccess("Contraseña restablecida con éxito. Puedes iniciar sesión ahora.");
         setTimeout(() => {
            navigate("/login");
         }, 2000);
      } catch (error) {
         setError("Error al restablecer la contraseña: " + error.message);
      }
   };

   return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
         <div className="max-w-md w-full space-y-8">
            <div className="bg-white shadow-xl rounded-lg p-8">
               <h2 className="text-3xl font-bold text-gray-900 text-center">
                  Restablecer Contraseña
               </h2>

               {error && (
                  <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
                     <div className="text-red-700 text-sm">{error}</div>
                  </div>
               )}

               {success && (
                  <div className="mb-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                     <div className="text-green-700 text-sm">{success}</div>
                  </div>
               )}

               <form onSubmit={handleResetPassword} className="space-y-6">
                  <div>
                     <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                        Email
                     </label>
                     <input
                        id="email"
                        name="email"
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="block w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="tu@email.com"
                     />
                  </div>

                  <div>
                     <label htmlFor="newPassword" className="block text-sm font-medium text-gray-700 mb-2">
                        Nueva Contraseña
                     </label>
                     <input
                        id="newPassword"
                        name="newPassword"
                        type="password"
                        required
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        className="block w-full border border-gray-300 rounded-lg py-3 px-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        placeholder="Tu nueva contraseña"
                     />
                  </div>

                  <div>
                     <button
                        type="submit"
                        className="w-full flex justify-center py-3 px-4 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                     >
                        Restablecer Contraseña
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </div>
   );
};

export default ResetPassword;